const settingsTexts = {
  THEME_UPDATED: 'Theme updated',
  THEME_UPDATE_ERROR: 'Error updating theme',
  TITLES: {
    BUNDLE_QUANTITY_FORMAT: 'Bundle and Popup quantity format',
    BALANCE_QUANTITY_FORMAT: 'Balance quantity format',
    SPECIAL_OFFER_QUANTITY_FORMAT: 'Special Offer quantity format',
    ROLLING_OFFER_QUANTITY_FORMAT: 'Rolling Offer quantity format'
  }
};

const actionTexts = {
  SAVE: 'Save',
  UPDATE: 'Update'
};

export const systemTexts = { settingsTexts, actionTexts };
